import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CircleNotch } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (err) {
        const msg =
          err?.response?.status === 403
            ? "This Google account isn't authorized for admin access."
            : "Sign-in failed. Please try again.";
        toast.error(msg);
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0B1E45] text-white gap-4">
      <CircleNotch size={40} weight="bold" className="animate-spin text-[#5DB82F]" />
      <p className="font-display font-bold tracking-wide">Signing you in…</p>
    </div>
  );
}
